export default "__VITE_ASSET__DtqtHkdN__"